import { z } from "zod";
import type { Endpoint } from "./types";

// ── Zod Schemas ────────────────────────────────────────────────────

export const specialtySchema = z.object({
  name: z.string(),
  slug: z.string(),
});

/** Handles both array and { data: [] } wrapper */
const specialtiesResponseSchema = z.union([
  z.array(specialtySchema),
  z.object({ data: z.array(specialtySchema) }).transform((r) => r.data),
]);

// ── Inferred Types ─────────────────────────────────────────────────

export type Specialty = z.infer<typeof specialtySchema>;

// ── Endpoints ──────────────────────────────────────────────────────

export const specialtyEndpoints = {
  list: {
    method: "GET",
    path: "/specialties",
    schema: specialtiesResponseSchema,
  } as Endpoint,
} as const;
